import { render } from "./CustomReportsPage.vue?vue&type=template&id=61a2d708&scoped=true&ts=true"
import script from "./CustomReportsPage.vue?vue&type=script&lang=tsx"
export * from "./CustomReportsPage.vue?vue&type=script&lang=tsx"

import "./CustomReportsPage.vue?vue&type=style&index=0&id=61a2d708&scoped=true&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a2d708"]])

export default __exports__